import {ReferralStepProps} from '../../Molecules/ReferralInstructionSteps/Step';
import {
  ReferralBanner,
  ReferralBannerProps,
} from '../../Molecules/ReferralBanner/ReferralBanner';
import {
  ReferralFAQProps,
  ReferralFAQSection,
} from '../../Molecules/ReferralFAQSection/ReferralFAQSection';
import React from 'react';
import {Stack} from '../../Layout';
import {MessageInfo, ReferralInstructionSteps} from '../../Molecules';
import {IconInfoOutline, Text, useDevice} from '../../Atoms';
import styles from './ReferralPage.module.css';

export type ReferralPageProps = {
  banner: ReferralBannerProps;
  instructionSteps: {
    title: string;
    steps: ReferralStepProps[];
    message?: string;
  };
  faqs: ReferralFAQProps;
};

export const ReferralPage = (props: ReferralPageProps) => {
  const {isMobile, isDesktop} = useDevice();
  return (
    <Stack space={isMobile ? 'xl' : '2xl'}>
      <ReferralBanner {...props.banner} />
      <Stack
        space={isDesktop ? 'lg' : 'md'}
        className={styles.instructionSteps}
      >
        <Text type={isDesktop ? 'smHero' : 'captionHeavy'} as="h2">
          {props.instructionSteps.title}
        </Text>
        <ReferralInstructionSteps steps={props.instructionSteps.steps} />
        {props.instructionSteps.message && (
          <MessageInfo
            icon={<IconInfoOutline size={24} />}
            text={props.instructionSteps.message ?? ''}
          />
        )}
      </Stack>
      {props.faqs.faqs.length > 0 && <ReferralFAQSection {...props.faqs} />}
    </Stack>
  );
};
